import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

TicketSubject.propTypes = {
  subject: PropTypes.string,
  sx: PropTypes.object,
};

export default function TicketSubject({ subject, sx = {} }) {

return <Typography
    color="secondary"
    variant="subtitle1"
    sx={{
      ...sx,
      textAlign: 'center',
      mr: 1,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      minWidth: 0,
      maxWidth: '100%'
    }}
  >
    {subject}
  </Typography>
}